import React from 'react';
import PropTypes from 'prop-types';
import {Input} from "reactstrap";
import useAfterUpdateEffect from "../../utils/useAfterUpdateEffect";
import {useTranslation} from "react-i18next";

const InputText = props => {
  const { t } = useTranslation('app_table')
  const [value, setValue] = React.useState(props.value)

  useAfterUpdateEffect(() => {
    if(value !== props.value){
      setValue(props.value)
    }
  }, [props.value])

  const handleOnFocus = (e) => {
    if(props.selectOnFocus){
      e.target.select()
    }
  }

  return (
    <Input
      autoFocus={props.autoFocus}
      className={props.className}
      placeholder={props.placeholder ?? t('input_text.placeholder')}
      onFocus={handleOnFocus}
      onKeyDown={e => {
        switch (e.key) {
          case 'Enter': {
            e.preventDefault();
            props.onChanged(value)
            break;
          }
          case 'Escape': {
            props.onCancel()
            break;
          }
        }
      }}
      onChange={e => setValue(e.target.value)}
      onBlur={e => props.onChanged(value)}
      value={value}
      style={props.style}
    />
  );
};

InputText.defaultProps = {
  autoFocus: false,
  selectOnFocus: false,
};

InputText.propTypes = {
  style: PropTypes.object,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  selectOnFocus: PropTypes.bool,
  className: PropTypes.string,
  value: PropTypes.string,
  onChanged: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default InputText;